module.exports = {"event_expiry":"Cette offre se termine dans "}